import { handleError } from "core/utils/HandleError";
import { handleResponse } from "core/utils/HandleResponse";
import { AuthHttpClient } from "core/utils/HttpClient";

export function getBracketPreview(
  tournamentId: string | number,
  bracketType: string,
  thirdPlaceMatch: string
) {
  return AuthHttpClient.get(
    `/admin/tournament/vs-mode/preview/${tournamentId}?bracketType=${bracketType}&thirdPlaceMatch=${thirdPlaceMatch}`
  )
    .then(handleResponse)
    .catch(handleError);
}
